import React, { useState } from 'react';
import styles from './MasterManager.module.css';


const MasterManager = ({
  title,
  description,
  inputValue,
  onInputChange,
  onSubmit,
  loading,
  items,
  onRemove,
  placeholder
}) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <h2
          style={{ margin: 0, fontSize: '1.2em', flex: 1, cursor: 'pointer', userSelect: 'none' }}
          onClick={() => setOpen(o => !o)}
        >
          {title}
        </h2>
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          aria-label={open ? '閉じる' : '開く'}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2em', lineHeight: 1 }}
        >
          {open ? '▲' : '▼'}
        </button>
      </div>
      {description && (
        <p style={{ margin: '4px 0 0 0', color: '#555', fontSize: '0.95em' }}>{description}</p>
      )}
      <div className={open ? `${styles.collapsible} ${styles.open}` : styles.collapsible}>
        <form onSubmit={onSubmit} className={styles.form}>
          <input
            type="text"
            value={inputValue}
            onChange={onInputChange}
            placeholder={placeholder}
            className={styles.input}
          />
          <button type="submit" className={styles.button}>追加</button>
        </form>
        {loading ? (
          <div>読み込み中...</div>
        ) : (
          <ul className={styles.brandList}>
            {items.map((item, idx) => (
              <li key={item.id || idx} className={styles.brandItem}>
                {item.name || item}
                <button onClick={() => onRemove(idx)} className={styles.deleteButton}>削除</button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MasterManager;
